// extracted by mini-css-extract-plugin
export default {"StarsContainer":"stars_StarsContainer__Gy-3k"};